const widgetsAddtionalOptionsWrapper = { position: 'absolute', top: '20px', left: '25px' };
const widgetsAddtionalOptions = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0.5rem',
};

export { widgetsAddtionalOptionsWrapper, widgetsAddtionalOptions };
